import React from 'react';
import SectionHeading from './SectionHeading';

const STEPS = [
  { count: '300+', label: 'Fixtures on the board', text: 'Every scheduled match across the leagues each tipster follows enters the daily review. Nothing is pre-selected by league prestige or kick-off time.' },
  { count: '~40', label: 'Pass the numbers', text: 'Form-adjusted ratings, expected goals and fair-price estimates flag where our view differs from the bookmaker — in the market the tipster specialises in.' },
  { count: '~8', label: 'Survive the context check', text: 'Line-ups, suspensions, rotation, travel and motivation are verified. Attractive numbers with the wrong context are removed here.' },
  { count: '1', label: 'Release', text: 'One Double, one handicap line or one single — depending on the tipster. If nothing qualifies, the day is published as “No pick”.' }
];

export default function SelectionProcess() {
  return (
    <section className="relative py-24 md:py-32 bg-navy text-white overflow-hidden grain" data-testid="process-section">
      <div className="absolute -left-40 top-20 w-[520px] h-[520px] rounded-full bg-royal/25 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading
          dark
          eyebrow="The selection process"
          title="Hundreds of matches reviewed. One release per tipster."
          lead="Each tipster runs the same funnel in their own market. The release is the end of a process, not the start of a list."
        />

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-3xl overflow-hidden border border-white/10">
          {STEPS.map((s, i) => (
            <div key={s.label} className="bg-navy p-7 md:p-8 relative group hover:bg-navy-soft transition-colors" data-testid={`process-step-${i}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] text-white/40">STEP 0{i + 1}</span>
                {i < STEPS.length - 1 && <span className="hidden lg:block text-white/20 group-hover:text-signal transition-colors">→</span>}
              </div>
              <div className={`mt-8 font-mono font-bold tracking-tight leading-none ${i === 3 ? 'text-signal text-6xl' : 'text-white text-5xl'}`}>{s.count}</div>
              <div className="mt-3 font-display font-semibold text-base md:text-lg">{s.label}</div>
              <p className="mt-3 text-sm text-slate-300/80 leading-relaxed">{s.text}</p>
              <div className="mt-6 h-1 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full bg-signal" style={{ width: `${100 - i * 31}%` }} />
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-slate-400 max-w-2xl">Counts are indicative of a typical day and vary with the fixture list. Our criteria do not bend to fill a slot.</p>
      </div>
    </section>
  );
}
